import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createStore } from "redux";
import { Provider } from 'react-redux';
import imageReducer from './reducers/imageReducer';
import aboutImageReducer from './reducers/imageReducer';

const store = createStore(imageReducer);


// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
  
  
//   document.getElementById('root')


// );
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
  <BrowserRouter>
      <App />
      <script src="/__/firebase/8.2.7/firebase-app.js"></script>
<script src="/__/firebase/8.2.7/firebase-analytics.js"></script>
<script src="/__/firebase/init.js"></script>
  </BrowserRouter>
  </Provider>
  </React.StrictMode>
  , 
  document.getElementById('root')
)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
